import React from 'react';
import PageHeader from '@atlaskit/page-header';
import ProjectPagesImprovementTitle from '../../ui/project-pages-improvement/title';
import { useThemeContext } from '../../ui/theme';
import * as Styled from '../styled';
import { type OwnProps as MoreMenuProps } from '../more-menu/types';

interface Header {
	isCrossSell: boolean;
	shouldShowMeatballMenu: boolean;
	MoreMenu: React.ComponentType<MoreMenuProps>;
	breadcrumbs: React.ReactElement<any>;
}
// eslint-disable-next-line @typescript-eslint/ban-types
const Header: React.FC<Header> = ({
	breadcrumbs,
	isCrossSell,
	MoreMenu,
	shouldShowMeatballMenu,
}) => {
	const theme = useThemeContext();

	const actions = shouldShowMeatballMenu ? <MoreMenu /> : undefined;

	return (
		<Styled.PageHeaderStyleWrapper theme={theme}>
			<PageHeader breadcrumbs={breadcrumbs} actions={actions}>
				<Styled.PageTitleStyleWrapper theme={theme}>
					<ProjectPagesImprovementTitle isPreExpand={isCrossSell} />
				</Styled.PageTitleStyleWrapper>
			</PageHeader>
		</Styled.PageHeaderStyleWrapper>
	);
};

export default Header;
